import React from "react";
import { connect } from "react-redux";
import language from "../../language";
import { Table } from "../Table";
import bloodTestQuery, {
  deletebloodtest,
  getBloodTestDashboardCounts,
  searchBloodTest,
} from "../../utils/queries/bloodTest/bloodTestQuery";
import { DeleteModal, Modal } from "../Modal";
import {
  defineRole,
  defineRoleCenterSite,
} from "../../utils/handleAccessRoles";
import { getStorage } from "../../utils/storage";
import icons from "../../constants/icons";
import { ROLE_BLOOD_TEST } from "../../constants/ROLES";
import BloodTestFilters from "../Filters/bloodTestFilters/BloodTestFilters";
import Worksheets from "./export/Worksheets";
import LabResults from "./LabResults";
import moment from "moment";
import toastMessage from "../../utils/toastMessage";
import CardCount from "../CardCount/CardCount";
import NewBloodTest from "./NewBloodTest";
import { renderDuBloodGroup } from "../../utils/bloodGroupInfo";

class BloodTesting extends React.Component {
  state = {
    isLoading: false,
    data: [],
    page: 1,
    limit: 10,
    search_text: "",
    selectedData: {},
    delete_value: "",
    error: {},
    csvData: [],
    user: {},
    counts: {
      testedBothEntries: 0,
      firstEntryBloodGrouping: 0,
      firstEntrySerology: 0,
      pending: 0,
    },
    filters: {
      startDate: moment().subtract(30, "d").format("YYYY-MM-DD"),
      endDate: moment().endOf("d").format("YYYY-MM-DD"),
    },
    showCountDetailsModal: false,
    countDetailsType: "",
    countDetailsTitle: "",
    isLoadingCountDetails: false,
    countDetailsData: [],
    countDetailsPage: 1,
    countDetailsLimit: 10,
    countDetailsTotalRecords: 0,
    countDetailsTotalPageCount: 0,
    countDetailsSearchText: "",
    searchingCountDetails: false,
  };

  componentDidMount = async () => {
    const user = await getStorage();
    this.setState({ user });

    this.fetchData(true, this.state.filters);
  };

  buildNextFilters = (params = {}) => {
    const nextFilters = {
      ...this.state.filters,
      ...params,
    };

    const hasQParam = Object.prototype.hasOwnProperty.call(params, "q");
    if (hasQParam && !params.q) {
      delete nextFilters.q;
    }

    return nextFilters;
  };

  fetchData = async (isLoading, params = {}) => {
    const nextFilters = this.buildNextFilters(params);

    this.setState(
      {
        filters: nextFilters,
        page: 1,
      },
      async () => {
        this.getData(isLoading, nextFilters);
        this.getAllCounts(isLoading, nextFilters);
      },
    );
  };

  onChangeText(field, e) {
    let { error } = this.state;

    delete error[field];

    this.setState({
      [field]: e?.target?.value,
      error,
    });
  }

  returnFilters = async (filters = {}) => {
    const { donationId, isSearch, donorId } = this.props;
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-unused-vars
    const { centerRole, centerSiteRole } = await defineRoleCenterSite();

    let params = {
      donor: donorId,
      donation: donationId,
      // center: centerRole,
      // centerSite: centerSiteRole,
      startCollectionDate: moment(filters.startDate)
        .startOf("D")
        .format("YYYY-MM-DD HH:mm"),
      endCollectionDate: moment(filters.endDate)
        .endOf("D")
        .format("YYYY-MM-DD HH:mm"),
      status:
        filters?.status?.value === "pending" ||
        filters?.status?.value === "completed"
          ? filters?.status?.value
          : undefined,
    };

    if (filters?.status?.value === "bloodGroupingTested") {
      params.bloodGroupingTested = true;
    }

    if (filters?.status?.value === "serologyTested") {
      params.serologyTested = true;
    }

    if (params?.search?.q) {
      delete params.startCollectionDate;
      delete params.endCollectionDate;
    }
    if (isSearch) {
      delete params.startCollectionDate;
      delete params.endCollectionDate;
      delete params.endDate;
      delete params.startDate;
    }
    return params;
  };

  getData = async (isLoading, search = {}) => {
    try {
      const { page, limit } = this.state;
      const { status } = this.props;
      const { defaultLanguage, isSearch } = this.props;

      this.setState({ isLoading });

      let additionalFilters = {};

      if (status === "bothEntries") {
        additionalFilters.bloodGroupingTestCount = 2;
        additionalFilters.serologyTestCount = 2;
      }

      if (status === "firstEntryBloodGrouping") {
        additionalFilters.bloodGroupingTestCount = 1;
      }

      if (status === "firstEntrySerology") {
        additionalFilters.serologyTestCount = 1;
      }

      if (status === "pending") {
        additionalFilters.tested = false;
      }

      let params = {
        page,
        limit,
        ...(await this.returnFilters(search)),
        ...additionalFilters,
        ...search,
      };

      const { data, count, totalRecords } = await bloodTestQuery(defaultLanguage, params);

      if (isSearch && data.length === 1) {
        window.location.href = `/dashboard/testing/${data[0]._id}/${data[0]?.donation?.donationNumber}`;

        return;
      }

      this.setState({
        data,
        totalPageCount: count,
        totalRecords,
        isLoading: false,
      });
    } catch (error) {
      this.setState({
        isLoading: false,
      });
      console.log(error);
      toastMessage("error", error);
    }
  };

  getAllCounts = async (isLoadingCounts, filters) => {
    try {
      const { defaultLanguage } = this.props;
      this.setState({ isLoadingCounts });

      const params = {
        ...(await this.returnFilters(filters)),
        ...filters,
      };

      delete params.page;
      delete params.limit;

      const counts = await getBloodTestDashboardCounts(defaultLanguage, params);

      this.setState({
        counts: {
          testedBothEntries: counts?.testedBothEntries || 0,
          firstEntryBloodGrouping: counts?.firstEntryBloodGrouping || 0,
          firstEntrySerology: counts?.firstEntrySerology || 0,
          pending: counts?.pending || 0,
        },
        isLoadingCounts: false,
      });
    } catch (error) {
      this.setState({
        isLoadingCounts: false,
      });
      toastMessage("error", error);
      console.log(error);
    }
  };

  getCountDetailsFilter = (countType) => {
    if (countType === "testedBothEntries") {
      return {
        status: "confirmed",
        bloodGroupingTestCount: 2,
        serologyTestCount: 2,
      };
    }

    if (countType === "firstEntryBloodGrouping") {
      return { bloodGroupingTestCount: 1 };
    }

    if (countType === "firstEntrySerology") {
      return { serologyTestCount: 1 };
    }

    if (countType === "pending") {
      return { tested: false };
    }

    return {};
  };

  getCountDetailsTotal = (countType) => this.state.counts?.[countType] || 0;

  getCountDetailsData = async (
    isLoading = false,
    page = this.state.countDetailsPage,
    countType = this.state.countDetailsType,
    searchText = this.state.countDetailsSearchText,
  ) => {
    if (!countType) return;

    try {
      const { defaultLanguage } = this.props;
      const baseParams = await this.returnFilters(this.state.filters);
      const filterByCountType = this.getCountDetailsFilter(countType);
      const trimmedSearchText = (searchText || "").trim();
      const hasSearch = trimmedSearchText !== "";
      const totalRecords = this.getCountDetailsTotal(countType);
      const limit = this.state.countDetailsLimit;

      this.setState({ isLoadingCountDetails: isLoading });

      const response = await bloodTestQuery(defaultLanguage, {
        ...baseParams,
        ...filterByCountType,
        page,
        limit,
        q: hasSearch ? trimmedSearchText : undefined,
      });
      const responseTotal =
        response?.totalRecords || (response?.count || 0) * limit;

      this.setState({
        countDetailsData: response?.data || [],
        countDetailsTotalRecords: hasSearch ? responseTotal : totalRecords,
        countDetailsTotalPageCount: Math.ceil(
          (hasSearch ? responseTotal : totalRecords) / limit,
        ),
        countDetailsPage: page,
        countDetailsType: countType,
        isLoadingCountDetails: false,
      });
    } catch (error) {
      this.setState({ isLoadingCountDetails: false });
    }
  };

  handleCountDetailsOpen = (countType, countTitle) => {
    const totalRecords = this.getCountDetailsTotal(countType);
    const limit = this.state.countDetailsLimit;

    this.setState(
      {
        showCountDetailsModal: true,
        countDetailsType: countType,
        countDetailsTitle: countTitle,
        countDetailsData: [],
        countDetailsPage: 1,
        countDetailsTotalRecords: totalRecords,
        countDetailsTotalPageCount: Math.ceil(totalRecords / limit),
        countDetailsSearchText: "",
        searchingCountDetails: false,
      },
      () => this.getCountDetailsData(true, 1, countType),
    );
  };

  handleCountDetailsClose = () => {
    this.setState({
      showCountDetailsModal: false,
      countDetailsType: "",
      countDetailsTitle: "",
      isLoadingCountDetails: false,
      countDetailsData: [],
      countDetailsPage: 1,
      countDetailsTotalRecords: 0,
      countDetailsTotalPageCount: 0,
      countDetailsSearchText: "",
      searchingCountDetails: false,
    });
  };

  handleCountDetailsPagination = (page) => {
    this.getCountDetailsData(true, page);
  };

  handleCountDetailsSearch = (e) => {
    this.setState({
      countDetailsSearchText: e?.target?.value || "",
    });
  };

  handleCountDetailsRemoteSearch = async () => {
    this.setState({
      searchingCountDetails: true,
    });

    await this.getCountDetailsData(
      true,
      1,
      this.state.countDetailsType,
      this.state.countDetailsSearchText,
    );

    this.setState({
      searchingCountDetails: false,
    });
  };

  returnCountDetailsHeaders = () => {
    const { defaultLanguage } = this.props;
    return [
      {
        title: language[defaultLanguage].donation,
        key: "donation.donationNumber",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[defaultLanguage].blood_group,
        key: "bloodGroup",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[defaultLanguage].center,
        key: "center.name",
      },
      {
        title: language[defaultLanguage].center_site,
        key: "centerSite.name",
      },
      {
        title: language[this.props.defaultLanguage].test_result,
        headers: [
          {
            title: language[this.props.defaultLanguage].blood_grouping_tested,
            key: "bloodGroupingTestCount",
            type: "countCheck",
          },
          {
            title: language[this.props.defaultLanguage].serology_tested,
            key: "serologyTestCount",
            type: "countCheck",
          },
        ],
      },
      {
        title: language[this.props.defaultLanguage].collection_date,
        headers: [
          {
            title: language[this.props.defaultLanguage].collection_date,
            key: "donation.collectionDate",
            isMoment: true,
            formatTime: "ll",
          },
          {
            title: language[this.props.defaultLanguage].collection_start_time,
            key: "donation.startTime",
          },
          {
            title: language[this.props.defaultLanguage].collection_end_time,
            key: "donation.endTime",
          },
        ],
      },
      // {
      //   title: language[defaultLanguage].blood_grouping_tested,
      //   key: "bloodGroupingTestCount",
      // },
      // {
      //   title: language[defaultLanguage].serology_tested,
      //   key: "serologyTestCount",
      // },
      {
        title: language[defaultLanguage].collection_date,
        key: "donation.collectionDate",
        isMoment: true,
        formatTime: "ll",
      },
      {
        title: language[defaultLanguage].status,
        key: "status",
        type: "status",
      },
    ];
  };

  handlePagination(page, _tab, limit) {
    this.setState(
      {
        page,
        ...(limit != null && { limit }),
      },
      () => {
        this.getData(true, this.state.filters);
      },
    );
  }

  handleLimitChange = (newLimit) => {
    this.setState({ limit: newLimit, page: 1 }, () => {
      this.getData(true, this.state.filters);
    });
  };

  returnTableHeaders() {
    let headers = [
      this.props.showLabResult && {
        title: language[this.props.defaultLanguage].lab_results,
        type: "labResult",
        onPress: (item) => {
          this.handleShowModal("showLabResults", item.code, item);
        },
      },
      {
        title: language[this.props.defaultLanguage].donation,
        key: "donation.donationNumber",
        type: "link",
        onPress: (item) =>
          (window.location.href = `/dashboard/testing/${item._id}/${item.donation.donationNumber}`),
        styles: {
          textTransform: "uppercase",
        },
        copyEnabled: true,
      },
      {
        title: language[this.props.defaultLanguage].blood_group,
        key: "bloodGroup",
        render: (item) => renderDuBloodGroup(item.bloodGroup),
      },
      {
        title: language[this.props.defaultLanguage].center,
        key: "center.name",
      },
      {
        title: language[this.props.defaultLanguage].center_site,
        key: "centerSite.name",
      },
      // {
      //   title: language[this.props.defaultLanguage].activate_donation,
      //   key: "activateDonation",
      // },
      // {
      //   title: language[this.props.defaultLanguage].date,
      //   key: "createdAt",
      //   isMoment: true,
      //   formatTime: "lll",
      // },
      {
        title: language[this.props.defaultLanguage].test_result,
        headers: [
          {
            title: language[this.props.defaultLanguage].blood_grouping_tested,
            key: "bloodGroupingTestCount",
            type: "countCheck",
          },
          {
            title: language[this.props.defaultLanguage].serology_tested,
            key: "serologyTestCount",
            type: "countCheck",
          },
        ],
      },
      {
        title: language[this.props.defaultLanguage].collection_date,
        headers: [
          {
            title: language[this.props.defaultLanguage].collection_date,
            key: "donation.collectionDate",
            isMoment: true,
            formatTime: "ll",
          },
          {
            title: language[this.props.defaultLanguage].collection_start_time,
            key: "donation.startTime",
          },
          {
            title: language[this.props.defaultLanguage].collection_end_time,
            key: "donation.endTime",
          },
        ],
      },
      // {
      //   title: language[this.props.defaultLanguage].collection_start_time,
      //   key: "donation.startTime",
      // },
      // {
      //   title: language[this.props.defaultLanguage].collection_end_time,
      //   key: "donation.endTime",
      // },
      {
        title: language[this.props.defaultLanguage].status,
        key: "status",
        type: "status",
      },
      {
        title: language[this.props.defaultLanguage].actions,
        key: "action",
      },
    ];

    return headers.filter(Boolean);
  }

  handleShowModal(modal, modalTitle, selectedData = {}) {
    this.setState({
      [modal]: true,
      modalTitle: modalTitle,
      selectedData,
    });
  }

  handleCloseModal(modal) {
    this.setState({
      [modal]: false,
    });
  }

  onDelete = async () => {
    try {
      this.setState({ isDeleting: true });

      await deletebloodtest(
        this.props.defaultLanguage,
        this.state.selectedData._id,
      );

      this.setState({ isDeleting: false });

      this.getData(true);
      this.handleCloseModal("showDeleteModal");
    } catch (error) {
      console.log(error);
      this.setState({
        isDeleting: false,
      });
    }
  };

  handleSearchButton = async () => {
    try {
      const { search_text } = this.state;
      const { defaultLanguage } = this.props;

      this.setState({ searching: true, page: 1 });

      const data = await searchBloodTest(defaultLanguage, {
        donorNumber: search_text,
      });

      console.log("searched results", data);
      this.setState({ data, searching: false });
    } catch (error) {
      console.log("Blood test error:", error);
      this.setState({ searching: false });
    }
  };

  handleRemoteSearch = async (search) => {
    await new Promise((r) => this.setState({ searching: true, page: 1 }, r));

    await this.fetchData(true, {
      q: search && search.trim() ? search.trim() : undefined,
    });

    this.setState({
      searching: false,
    });
  };

  renderCounts() {
    return (
      <div className="row">
        <div className="col-md-3 ">
          <CardCount
            count={this.state.counts.testedBothEntries}
            title={language[this.props.defaultLanguage].tested_both_entries}
            color="#078ECE"
            icon="check"
            isLoading={this.state.isLoadingCounts}
            onPress={() =>
              this.handleCountDetailsOpen(
                "testedBothEntries",
                language[this.props.defaultLanguage].tested_both_entries,
              )
            }
            isActive={this.props.status === "bothEntries"}
          />
        </div>
        <div className="col-md-3 ">
          <CardCount
            count={this.state.counts.firstEntryBloodGrouping}
            title={
              language[this.props.defaultLanguage].first_entry_blood_grouping
            }
            color="orange"
            icon="labs"
            isLoading={this.state.isLoadingCounts}
            onPress={() =>
              this.handleCountDetailsOpen(
                "firstEntryBloodGrouping",
                language[this.props.defaultLanguage].first_entry_blood_grouping,
              )
            }
            isActive={this.props.status === "firstEntryBloodGrouping"}
          />
        </div>
        <div className="col-md-3 ">
          <CardCount
            count={this.state.counts.firstEntrySerology}
            title={language[this.props.defaultLanguage].first_entry_serology}
            color="purple"
            icon="lab_panel"
            isLoading={this.state.isLoadingCounts}
            onPress={() =>
              this.handleCountDetailsOpen(
                "firstEntrySerology",
                language[this.props.defaultLanguage].first_entry_serology,
              )
            }
            isActive={this.props.status === "firstEntrySerology"}
          />
        </div>
        <div className="col-md-3 ">
          <CardCount
            count={this.state.counts.pending}
            title={language[this.props.defaultLanguage].pending}
            color="gray"
            icon="downloading"
            isLoading={this.state.isLoadingCounts}
            onPress={() =>
              this.handleCountDetailsOpen(
                "pending",
                language[this.props.defaultLanguage].pending,
              )
            }
            isActive={this.props.status === "pending"}
          />
        </div>
      </div>
    );
  }

  render() {
    // if (this.state.isLoading) return <Loading className="fullscreen" />;
    return (
      <>
        <Table
          data={this.state.data}
          isSearch
          page={this.state.page}
          limit={this.state.limit}
          search_text={this.state.search_text}
          placeholder={`${language[this.props.defaultLanguage].search} ${
            this.props.status || ""
          }`}
          handleSearch={(e) => this.onChangeText("search_text", e)}
          addSearchButton
          searching={this.state.searching}
          handlePressSearch={() =>
            this.handleRemoteSearch(this.state.search_text)
          }
          totalPageCount={this.state.totalPageCount}
          totalRecords={this.state.totalRecords}
          isLoading={this.state.isLoading}
          handlePagination={this.handlePagination.bind(this)}
          onLimitChange={this.handleLimitChange}
          headers={this.returnTableHeaders()}
          fetchData={(isLoading, search) => this.fetchData(isLoading, search)}
          showAdd={
            this.state.data.length === 0 &&
            !this.props.donorId &&
            defineRole({
              roles: this.state.user.accessRole,
              menu: ROLE_BLOOD_TEST,
              operation: "create",
            })
          }
          addButtonText={language[this.props.defaultLanguage].create}
          handleAddPressed={() =>
            this.state.data.length === 0
              ? this.handleShowModal(
                  "showSearchModal",
                  language[this.props.defaultLanguage].search,
                )
              : null
          }
          rowPress={(item) =>
            (window.location.href = `/dashboard/testing/${item._id}/${item?.donation?.donationNumber}`)
          }
          filters={[
            {
              type: "button",
              title: language[this.props.defaultLanguage].refresh,
              button_type: "button",
              icon: icons.refresh,
              onPress: (item) => this.fetchData(true, this.state.filters),
            },
            !this.props.donorId && {
              type: "dropdown",
              filterName: "center",
              title: language[this.props.defaultLanguage].center,
              button_type: "dropdown",
              handleApplyFilters: (isLoading, search) =>
                this.fetchData(isLoading, search),
            },
            !this.props.donorId && {
              type: "dropdown",
              filterName: "bloodGroup",
              title: language[this.props.defaultLanguage].blood_group,
              button_type: "dropdown",
              handleApplyFilters: (isLoading, search) =>
                this.fetchData(isLoading, search),
            },
            !this.props.donorId && {
              type: "dropdown",
              filterName: "date_range",
              title: language[this.props.defaultLanguage].date_range,
              button_type: "dropdown",
              handleApplyFilters: (isLoading, search) =>
                this.fetchData(isLoading, search),
              startDate: this.state.filters.startDate,
              endDate: this.state.filters.endDate,
            },
            // {
            //   type: "button",
            //   title: language[this.props.defaultLanguage].filters,
            //   button_type: "button",
            //   icon: icons.filters,
            //   onPress: (item) =>
            //     this.handleShowModal(
            //       "filtersModal",
            //       language[this.props.defaultLanguage].filters
            //     ),
            // },
            !this.props.donorId && {
              type: "button",
              title: language[this.props.defaultLanguage].generate_work_sheet,
              button_type: "button",
              icon: icons.export,
              onPress: (item) =>
                this.handleShowModal(
                  "exportModal",
                  language[this.props.defaultLanguage].generate_work_sheet,
                ),
              className: "primary",
            },
          ].filter(Boolean)}
          actions={[
            {
              canAccess: defineRole({
                roles: this.state.user.accessRole,
                menu: ROLE_BLOOD_TEST,
                operation: "testResult",
              }),
              name: language[this.props.defaultLanguage].results,
              onPress: (item) =>
                (window.location.href = `/dashboard/testing/${item._id}`),
              icon: icons.eye_on,
            },
            {
              canAccess: defineRole({
                roles: this.state.user.accessRole,
                menu: ROLE_BLOOD_TEST,
                operation: "delete",
              }),
              name: language[this.props.defaultLanguage].delete,
              onPress: (item) =>
                this.handleShowModal(
                  "showDeleteModal",
                  language[this.props.defaultLanguage].delete,
                  item,
                ),
              icon: icons.delete,
            },
          ]}
          counts={!this.props.donorId && this.renderCounts()}
        />

        <Modal
          handleClose={this.handleCountDetailsClose}
          show={this.state.showCountDetailsModal}
          title={`${this.state.countDetailsTitle} (${this.state.countDetailsTotalRecords})`}
          size="xl"
        >
          <div className="card-body">
            <Table
              data={this.state.countDetailsData}
              isSearch
              page={this.state.countDetailsPage}
              limit={this.state.countDetailsLimit}
              search_text={this.state.countDetailsSearchText}
              handleSearch={this.handleCountDetailsSearch}
              addSearchButton
              searching={this.state.searchingCountDetails}
              handlePressSearch={this.handleCountDetailsRemoteSearch}
              totalPageCount={this.state.countDetailsTotalPageCount}
              totalRecords={this.state.countDetailsTotalRecords}
              isLoading={this.state.isLoadingCountDetails}
              handlePagination={this.handleCountDetailsPagination}
              headers={this.returnCountDetailsHeaders()}
              rowPress={(item) =>
                (window.location.href = `/dashboard/testing/${item._id}/${item?.donation?.donationNumber}`)
              }
              actions={[]}
            />
          </div>
        </Modal>

        <Modal
          handleClose={this.handleCloseModal.bind(this, "showSearchModal")}
          show={this.state.showSearchModal}
          title={this.state.modalTitle}
        >
          <NewBloodTest
            handleCloseModal={this.handleCloseModal.bind(
              this,
              "showSearchModal",
            )}
            getData={() => this.getData(true, {})}
          />
        </Modal>
        <Modal
          handleClose={this.handleCloseModal.bind(this, "filtersModal")}
          show={this.state.filtersModal}
          title={this.state.modalTitle}
        >
          <div className="card-body">
            <div className="row">
              <BloodTestFilters
                fetchData={(isLoading, params) => {
                  this.fetchData(isLoading, params);
                }}
                handleCloseModal={this.handleCloseModal.bind(
                  this,
                  "filtersModal",
                )}
              />
            </div>
          </div>
        </Modal>
        <Modal
          handleClose={this.handleCloseModal.bind(this, "exportModal")}
          show={this.state.exportModal}
          title={this.state.modalTitle}
          size="fullscreen"
        >
          <div className="card-body">
            <div className="row">
              <Worksheets />
            </div>
          </div>
        </Modal>
        <Modal
          handleClose={this.handleCloseModal.bind(this, "showDeleteModal")}
          show={this.state.showDeleteModal}
          title={this.state.modalTitle}
        >
          <DeleteModal
            handleCloseModal={this.handleCloseModal.bind(
              this,
              "showDeleteModal",
            )}
            error={this.state.error.delete_password}
            value={this.state.delete_value}
            onDelete={this.onDelete.bind(this)}
            onChange={(e) => this.onChangeText("delete_value", e)}
            isDeleting={this.state.isDeleting}
            name={this.state.selectedData._id}
            getData={this.getData.bind(this)}
          />
        </Modal>

        <Modal
          handleClose={this.handleCloseModal.bind(this, "showLabResults")}
          show={this.state.showLabResults}
          title={this.state.modalTitle}
          size="fullscreen"
        >
          <LabResults testId={this.state.selectedData?._id} />
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(BloodTesting);
